import { createRouter, createWebHistory } from 'vue-router'
import Collection from '../views/Collection.vue'
import Vendor from '../views/Vendor.vue'
import Account from '../views/Account.vue'
import Creator from '../views/Creator.vue'
import CreatorEdit from '../views/CreatorEdit.vue'
import CreatorListing from '../views/CreatorListing.vue'
import Home from '../views/Home.vue'
import ReportAbuse from '../views/ReportAbuse.vue'
import Login from '../views/Login.vue'
import Admin from '../views/Admin.vue'
import Detail from '../views/Detail.vue'
import Error404 from '../views/404.vue'
import Guideline from '../views/Guideline.vue'
import store from '../store'

const routes = [
	{
		path: '/detail/:id/:page',
		name: 'Detail',
		component: Detail,
		meta: {
			allowed: [
				'PL_Public',
			]
		}
	},
	{
		path: '/collection/',
		name: 'Collection',
		component: Collection,
		meta: {
			allowed: [
				'logged_in',
			]
		}
	},
	{
		path: '/vendor/:id',
		name: 'Vendor',
		component: Vendor,
		props: true,
	},
	{
		path: '/account/',
		name: 'Account',
		component: Account,
		meta: {
			creator: true,
			allowed: [
				'logged_in',
			]
		}
	},
	{
		path: '/creator/',
		name: 'Creator',
		component: Creator,
		meta: {
			creator: true,
			allowed: [
				'logged_in',
			]
		}
	},
	{
		path: '/creator/edit/:id',
		name: 'CreatorEdit',
		component: CreatorEdit,
		props: true,
		meta: {
			creator: true,
			allowed: [
				'logged_in',
			]
		}
	},
	{
		path: '/creator/edit/:id/listing/',
		name: 'CreatorListing',
		component: CreatorListing,
		props: true,
		meta: {
			creator: true,
			allowed: [
				'logged_in',
			]
		}
	},
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			startpage: true,
		}
	},
	{
		path: '/abuse/:id',
		name: 'ReportAbuse',
		component: ReportAbuse,
		props: true,
		meta: {
			allowed: [
				'logged_in',
			]
		}
	},
	{
		path: '/login/',
		name: 'Login',
		component: Login,
	},
	{
		path: '/admin/',
		name: 'Admin',
		component: Admin,
		meta: {
			allowed: [
				//'GR_Admin'
			]
		}
	},
	{
		path: "/:pathMatch(.*)*",
		name: 'Error404',
		component: Error404,
	},
	{
		path: '/guideline/',
		name: 'Guideline',
		component: Guideline,
		meta: {
		}
	},
]

const router = createRouter({
	mode: 'history',
	history: createWebHistory(process.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) => {
	//Check if creator page or not
	if(to.matched.some(record => record.meta.creator)) {
		store.state.creatorPage = true;
	}else{
		store.state.creatorPage = false;
	}

	//Check if startpage page or not
	if(to.matched.some(record => record.meta.startpage)) {
		store.state.startPage = true;
	}else{
		store.state.startPage = false;
	}
	
	next()
})

export default router
